import { PERMISSION } from './keys';
import { RULES } from './registry';
import { ROLES } from '@/utils/constants';

/**
 * Resolve whether a role may use a feature, accounting for POS integration.
 *
 * @param {PERMISSION} key - the feature being checked
 * @param {number} roleLevel - the current user's numeric role level (auth/getRoleLevel)
 * @param {boolean} isPosIntegrated - whether the location is POS integrated
 * @return {boolean} true if the role is granted access
 */
export function hasPermission(key: PERMISSION, roleLevel: number, isPosIntegrated: boolean): boolean {
	const rule = RULES[key];
	if (!rule) {
		return false; // unknown permission — fail closed
	}
	// Admin gets every capability via a blanket grant;
	// rules that set stopAdminBypass opt out so admin is never treated as a staff/kiosk terminal.
	if (!rule.stopAdminBypass && roleLevel === ROLES.admin) {
		return true;
	}
	return rule[isPosIntegrated ? 'pos' : 'nonPos'].includes(roleLevel);
}
